module.exports = __webpack_public_path__ + "public/Icons/wheelchair.svg?a4320c0d";